export default __webpack_public_path__ + "static/Elido-Bold-6206978282253115249625de5f1d6347.woff2";